import * as _ from 'lodash';
import { FormEvent, useEffect, useState } from 'react';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, AutomatedJobActionCreators, IManualRunResponse, IQaCronListResponse, IQaCron } from '@nkr/store/index';
import { Alert, Button, Form, FormControl, Modal, Table } from 'react-bootstrap';
import Grid from './grid';

interface IOwnProps { }

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getCronList: () => Promise<IQaCronListResponse>,
    runManually: (id: number, alternate: boolean) => Promise<IManualRunResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

const Tasks = (props: TProps) => {
    const [list, setList] = useState<IQaCron[]>([]);
    const [confirm, setConfirm] = useState<{ show: boolean, id: number, alternate: boolean }>({ show: false, id: 0, alternate: false });
    const [results, setResults] = useState<{ runResults: number, id: number }>(null);
    const [message, setMessage] = useState('');
    const [search, setSearch] = useState('');

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        props.showLoading('Loading jobs, one moment please...').then(() => {
            props.getCronList()
                .then(response => {
                    let list = response.data.results;

                    if (response.data.success) {
                        setList(list);
                    }
                })
                .finally(() => {
                    props.hideLoading();
                });
        });
    };

    const runManually = (id: number, alternate: boolean) => {
        props.showLoading('Running task, one moment please...').then(() => {
            props.runManually(id, alternate)
                .then(response => {
                    setResults({ runResults: response.data.results, id });
                    setMessage(response.data.message);
                })
                .finally(() => {
                    props.hideLoading();
                });
        });
    };

    const handleConfirmRunManually = (id: number, alternate: boolean) => {
        setResults(null);
        setMessage('');

        setConfirm({
            show: true,
            id,
            alternate
        });
    };

    const handleContinueRunManually = () => {
        let { id, alternate } = confirm;

        setConfirm({
            show: false,
            id: 0,
            alternate: false
        });

        runManually(id, alternate);
    };

    const handleCancelRunManually = () => {
        setConfirm({
            show: false,
            id: 0,
            alternate: false
        });
    };

    const handleSearchChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        setSearch(e.currentTarget.value);
    };

    const filteredList = list.filter(x => {
        let s = search.length >= 3 ? x.taskId.toLowerCase().indexOf(search.toLowerCase()) >= 0 || x.description.toLowerCase().indexOf(search.toLowerCase()) >= 0 : true;
        return s;
    });

    const task = filteredList.find(x => x.id == results?.id || x.id == confirm?.id);
    const taskName = task?.description || '';

    return (
        <>
            <div className='container-fluid'>
                {results != null && results.runResults == 1 &&
                    <Alert bsStyle='success'>
                        <span>{taskName} completed successfully</span>
                    </Alert>
                }

                {results != null && results.runResults == 0 &&
                    <Alert bsStyle='warning'>
                        <span>Unable to find task {taskName}</span>
                    </Alert>
                }

                {results != null && results.runResults == -1 &&
                    <Alert bsStyle='danger'>
                        <div>
                            <div style={{ marginBottom: 5 }}>The following exception occurred while trying to run task {taskName}...</div>
                            <div>{message}</div>
                        </div>
                    </Alert>
                }

                <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', height: 30, marginBottom: 20 }}>
                    <div style={{ flexBasis: '33%', fontSize: 28, fontWeight: 500 }}>
                        TASKS (CRONS)
                    </div>
                    <div style={{ flexBasis: '33%' }}></div>
                    <div style={{ flexBasis: '33%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}></div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
                    <div style={{ marginRight: 5 }}>Search:</div>
                    <div style={{ flexBasis: 500 }}>
                        <FormControl
                            placeholder='Start typing, after 3 characters the list will be filtered...'
                            value={search}
                            onChange={handleSearchChange}
                        />
                    </div>
                </div>

                <Grid
                    data={filteredList}
                    onConfirmRunManually={handleConfirmRunManually} />
            </div>

            <Modal show={confirm.show} backdrop='static' onHide={handleCancelRunManually}>
                <Modal.Header><Modal.Title className='text-danger'>WARNING!</Modal.Title></Modal.Header>
                <Modal.Body>
                    <Alert bsStyle='info' bsSize='sm'>{taskName || ''}</Alert>
                    <div className='text-danger'>
                        Please verify you are not in production before clicking Continue
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle='danger' onClick={handleContinueRunManually}>Continue</Button>
                    <Button onClick={handleCancelRunManually}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        // automatedJobs: appState.automatedJobs,
        // app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getCronList: () => {
            return dispatch(AutomatedJobActionCreators.getQaCronList());
        },
        runManually: (id, alternate) => {
            return dispatch(AutomatedJobActionCreators.runManually(id, alternate));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(Tasks);